export const SUBMITTED_ANKETA_MODAL_WARNING = 'Отменить или перенести заявку можно через поддержку';
const SUBMITTED_ANKETA_MODAL_SUBTITLE_WITHOUT_PHONE = 'Партнёр Циана скоро позвонит';

export const buildSubmittedAnketaModalSubtitle = (phone: string | null): string =>
  phone ? `Партнёр Циана позвонит на ${phone}` : SUBMITTED_ANKETA_MODAL_SUBTITLE_WITHOUT_PHONE;
